<template>
    <mslPage :show-msg="false" :aIndex="2">
        <template v-slot:mslBody>

                <div class="news">
                    <div class="banner">
                        <div style="height: 74px; width: 100%;"></div>
                        <div class="center m_center banner_center flex flex-dir-top flex-cross-top flex-main-center">
                            <div class="b_title" v-if="baseInfo.news_banner && baseInfo.news_banner.id">{{ baseInfo.news_banner.title }}</div>
                            <div class="b_intro" v-if="baseInfo.news_banner && baseInfo.news_banner.id" v-html="baseInfo.news_banner.content"></div>
                        </div>
                    </div>
                    <div class="center m_center news_center column_center">
                        <el-row v-loading="loading">
                            <div class="list flex flex-dir-left flex-wrap" v-if="list && list.length > 0">
                                <router-link :to="{ name: 'news_detail', query: { id: item.id } }" v-for="(item, index) in list" :key="index" class="td_none item pointer leave_slowly hover_slowly">
                                    <div class="" style="overflow: visible;">
                                        <img :src="[ item.image_path ? item.image_path : '../assets/pc_pic/new/no_data.png' ]" alt="" v-if="item.image_path">
                                        <img src="../assets/pc_pic/new/no_data.png" alt="" v-else>
                                        <div class="txt">
                                            <div class="title w d_ellipsis">{{ item.title }}</div>
                                            <div class="intro w m_ellipsis" v-html="item.content"></div>
                                            <div class="more">
                                                <span>查看详情</span>
                                                <span class="iconfont iconarrow_right-23 icon"></span>
                                            </div>
                                        </div>
                                    </div>
                                </router-link>
                            </div>
                            <noData v-if="list && list.length == 0 && !loading"></noData>
                        </el-row>
                        <div class="page row_center">
                            <el-pagination
                                    :page-size="9"
                                    :pager-count="5"
                                    layout="prev, pager, next"
                                    :total="len"
                                    @current-change="getCurrentPage"
                                    hide-on-single-page>
                            </el-pagination>
                        </div>
                    </div>
                </div>

        </template>
    </mslPage>
</template>

<script>
    import { newsList, baseInfo } from '../api/common.js'
    import noData from '../components/no_data'

    export default {
        name: "news",
        components: {
            noData
        },
        data() {
            return {
                img: '../assets/pc_pic/new/no_data.png',
                currentPage: 1,
                baseInfo: {},
                list: [],
                formData: {
                    page: 1,
                    limit: 9,
                    diyname: 'news'
                },
                len: null,
                loading: false
            }
        },
        mounted() {
            this.getList(1);
            this.getBaseInfo();
        },
        methods: {
            getBaseInfo () {
                baseInfo().then(res => {
                    if(res.code == 1) {
                        this.baseInfo = res.data;
                        console.log(this.baseInfo);
                    } else {
                        this.$message.error('获取数据失败，请刷新')
                    }
                })
                // try {
                //
                // } catch {
                //     this.$message.error('获取数据失败，请刷新')
                // }
            },
            getCurrentPage (e) {
                this.currentPage = e;
                this.getList(this.currentPage);
                window.scrollTo(0, 0);//回到顶部
            },
            async getList (page) {
                try {
                    let len = this.len;
                    let list = this.list;
                    this.formData.page = page;
                    let data = {
                        ...this.formData
                    }
                    this.loading = true;
                    let res = await newsList(data);
                    if (res.code == 1) {
                        list = res.data.list;
                        len = Number(res.data.total);
                        this.list = list;
                        this.len = len;
                        this.loading = false;
                        // 内容处理
                        this.list.forEach((item, index) => {
                            if (!!item.content) {
                                let content = item.content;
                                content = content.replace(/(\n)/g, "");
                                content = content.replace(/(\t)/g, "");
                                content = content.replace(/(\r)/g, "");
                                content = content.replace(/<\/?[^>]*>/g, "");
                                content = content.replace(/\s*/g, "");
                                item.content = content;
                                console.log(item.content, 'item.content');
                            }
                        })
                    }
                } catch {
                    this.loading = false;
                    this.$message.error('加载数据失败，请刷新');
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    p {
        margin: 0!important;
        margin-block-start: 0!important;
        margin-block-end: 0!important;
    }
    .news {
        .banner {
            width: 100%;
            height: 365px;
            background: #fafafa url("../assets/pc_pic/new/news_banner.png") no-repeat center center;
            background-size: cover;
            .banner_center {
                height: 290px;
                .b_title {
                    font-size: 46px;
                    font-family: Microsoft YaHei;
                    font-weight: bold;
                    line-height: 54px;
                    color: #333333;
                }
                .b_intro {
                    font-size: 16px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    line-height: 24px;
                    color: #8C8C8C;
                    margin-top: 16px;
                    &::v-deep {
                        p {
                            margin-top: 0!important;
                            margin-bottom: 0!important;
                        }
                    }
                }
            }
        }
        .news_center {
            padding: 52px 0;
            overflow: visible!important;
            .list {
                min-width: 1280px;
                width: 100%;
                overflow: visible!important;
                margin-top: 10px;
                .item {
                    width: 30.68%;
                    background: #FFFFFF;
                    border: 1px solid #F0F0F0;
                    border-radius: 12px;
                    margin-right: 3.72%;
                    margin-bottom: 48px;
                    overflow: hidden;
                    &:nth-child(3n) {
                        margin-right: 0;
                    }
                    &:nth-last-child(1), &:nth-last-child(2), &:nth-last-child(3), {
                        margin-bottom: 0;
                    }
                    &:hover {
                        box-shadow: 0px 20px 30px rgba(0, 0, 0, 0.1);
                        .more {
                            color: #1890FF!important;
                        }
                    }
                    img {
                        width: 100%;
                        height: 244px;
                    }
                    .txt {
                        width: 100%;
                        padding: 28px 24px 80px 24px;
                        box-sizing: border-box;
                        .title {
                            font-size: 24px;
                            font-weight: bold;
                            line-height: 32px;
                            color: #262626;
                        }
                        .intro {
                            margin-top: 8px;
                            font-size: 16px;
                            font-weight: 400;
                            line-height: 24px;
                            color: #8C8C8C;
                            &::v-deep {
                                p {
                                    margin-top: 0px!important;
                                    margin-bottom: 0px!important;
                                }
                            }
                        }
                        .more {
                            margin-top: 20px;
                            font-size: 16px;
                            font-weight: 400;
                            line-height: 24px;
                            color: #262626;
                            .icon {
                                font-size: 20px;
                                line-height: 24px;
                                margin-left: 4px;
                            }
                        }
                    }
                }
            }
            .page {
                padding-top: 48px;
            }
        }
    }
</style>
